import { combineReducers } from "redux";
import { autocompleteReducer } from "./autocomplete";
import { authenticationReducer } from "./authentication";
import { billingReducer } from "./billing";
import { dealerMaterialReducer } from "./dealer_material";
import { endCustomerReducer } from "./end_customer";
import { eventReducer } from "./event";
import { priceListReducer } from "./price_list";
import { marketReducer } from "./market";
import { orderReducer } from "./order";
import { quoteReducer } from "./quote";
import { selfOrderReducer } from "./self_order";
import { historyReducer } from "./history";
import { shopMaterialReducer } from "./shop_material";
import { shopQuoteReducer } from "./shop_quote";
import { signatureReducer } from "./signature";
import { sketchReducer } from "./sketch";
import { uiReducer } from "./ui";

const reducers = combineReducers({
  autocomplete: autocompleteReducer,
  authentication: authenticationReducer,
  billing: billingReducer,
  dealer_material: dealerMaterialReducer,
  end_customer: endCustomerReducer,
  event: eventReducer,
  price_list: priceListReducer,
  history: historyReducer,
  market: marketReducer,
  order: orderReducer,
  quote: quoteReducer,
  shop_material: shopMaterialReducer,
  shop_quote: shopQuoteReducer,
  self_order: selfOrderReducer,
  signature: signatureReducer,
  sketch: sketchReducer,
  ui: uiReducer
});

export default reducers;

export type RootState = ReturnType<typeof reducers>;
